import React from "react";
import "./About.css";

const OurStory = () => {
  return (
    <section className="backdiv">

     

        <div className="story-grid">

          <div className="d-flex align-items-center justify-content-center">


            <h2 className="main-title">
              Building Digital
             <br/> Success Stories
            </h2>

          </div>

      
          <div >

              <div className="story-text">

                <p className="main-text">
                  Every successful business begins with a vision.<br/>
                  VedAstra was established to bridge the gap between business
                  ambition and technological excellence.<br/>
            
                  We recognized that many organizations invest in technology
                  without finding a partner who truly understands their
                  long-term vision. VedAstra was created to change that.<br/>
                  Today, our team brings together strategists, developers,
                  designers, marketers, and innovators who share one belief - 
                  technology should simplify business, accelerate growth, and
                  create sustainable value.<br/>

                <b>
                  Every project is approached with curiosity, precision, and a
                  relentless pursuit of excellence.</b>
                </p>

              </div>

          </div>

        </div>

    

    </section>
  );
};

export default OurStory;